// import Checkbox from '@material-ui/core/Checkbox'

import { withStyles } from '@material-ui/core/styles'
import cn from 'classnames'
import React from 'react'
// import { Check, Close } from '@material-ui/icons';
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd'

import Checkbox from '../Checkbox'
import Icon from '../Icon'
import Modal from '../Modal/Modal'
import { Text } from '../Typography'

const styles = theme => ({
  content: {
    paddingRight: '20px',
    paddingLeft: '20px',
  },
  cell10: {
    width: '15%',
    textAlign: 'left',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  cell80: {
    width: '80%',
    textAlign: 'left',
    paddingTop: 0,
    paddingBottom: 0,
    padding: '5px 6px !important',
    display: 'flex',
    alignItems: 'center',
  },
  row: {
    color: `var(--gameday-table-tableTextColor, ${theme.table.tableTextColor})`,
    backgroundColor: `var(--gameday-table-tableBgColor, ${theme.table.tableBgColor})`,
    height: '40px',
    display: 'flex',
    justifyContent: 'center',
    borderBottom: theme.borders.default,
    fontSize: theme.typography.fontSizeSm,
  },
  headerRow: {
    color: `var(--gameday-table-tableHeaderTextColor, ${theme.table.tableHeaderTextColor})`,
    fontWeight: theme.typography.fontWeightBolder,
    backgroundColor: `var(--gameday-table-tableHeaderBgColor, ${theme.table.tableHeaderBgColor})`,
    borderRadius: 4,
    height: 30,
    borderBottom: 'none',
    fontSize: theme.typography.fontSizeSmaller,
  },
  'button-sort': {
    width: '.6em',
    height: '1.5em',
    float: 'right',
    cursor: 'pointer',
    position: 'relative',
  },
})
class TableSettingModal extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      fields: props.headers
        .filter(header => header && !header.isFixedColumn)
        .map((header, index) => ({
          ...header,
          order: index,
        })),
      originalFields: props.headers.map((header, index) => ({
        ...header,
        order: index,
      })),
    }
    this.toggleModal = this.toggleModal.bind(this)
    this.onClickCheckBox = this.onClickCheckBox.bind(this)
    this.onSave = this.onSave.bind(this)
    this.onDragEnd = this.onDragEnd.bind(this)
  }

  onSave() {
    const { onSave } = this.props
    const { fields, originalFields } = this.state
    let delta = 0
    for (let i = 0; i < originalFields.length; i += 1) {
      if (i + 1 < originalFields.length && originalFields[i].isFixedColumn && !originalFields[i + 1].isFixedColumn) {
        delta = i + 1
        break
      }
    }
    if (onSave) {
      onSave(
        [
          ...originalFields.filter(header => header.isFixedColumn),
          ...fields.map(field => ({
            ...field,
            order: field.order + delta,
          })),
        ].sort((a, b) => a.order - b.order)
      )
    }
  }

  onClickCheckBox(field, isChecked) {
    const { fields } = this.state
    const newFields = (fields || []).map(fieldObject => ({
      ...fieldObject,
      isHiddenColumn: fieldObject.name === field.name ? !isChecked : fieldObject.isHiddenColumn,
    }))
    this.setState({
      fields: newFields,
    })
  }

  onDragEnd(result) {
    this.swapOrder(result.source.index, result.destination.index)
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.headers) {
      this.setState({
        fields: nextProps.headers
          .filter(header => header && !header.isFixedColumn)
          .map((header, index) => ({
            ...header,
            order: index,
          })),
        originalFields: nextProps.headers.map((header, index) => ({
          ...header,
          order: index,
        })),
      })
    }
  }

  toggleModal() {
    const { toggleModal } = this.props
    if (toggleModal) {
      toggleModal()
    }
  }

  swapOrder(source, destination) {
    const { fields } = this.state
    let tempField = [...fields]
    tempField[source].order = destination
    tempField = tempField.map((field, index) => {
      if (index >= destination && index < source) {
        return { ...field, order: field.order + 1 }
      }
      if (index > source && index <= destination) {
        return { ...field, order: field.order - 1 }
      }
      return field
    })
    this.setState({
      fields: [...tempField.sort((a, b) => a.order - b.order)],
    })
  }

  renderRow() {
    const { fields } = this.state
    const { classes, disableReArrange } = this.props
    return (fields || [])
      .filter(field => !field.isExportOnly)
      .map((field, index) => (
        <Draggable key={field.name} draggableId={field.name} index={index} isDragDisabled={disableReArrange}>
          {provided => (
            <div
              className={classes.row}
              ref={provided.innerRef}
              {...provided.draggableProps}
              {...provided.dragHandleProps}
            >
              {!disableReArrange && (
                <div className={classes.cell10}>
                  {/** biome-ignore lint/a11y/noStaticElementInteractions: TODO */}
                  <div
                    role="presentation"
                    className={classes['button-sort']}
                    onClick={() => this.onSort(field)}
                    aria-label="Sort"
                  >
                    <Icon iconName="fieldDragHandle" iconSize="10" />
                  </div>
                </div>
              )}
              <div className={classes.cell80}>{field.text}</div>
              <div className={classes.cell10}>
                <Checkbox
                  disabled={field.isAlwaysVisible}
                  name={index}
                  // biome-ignore lint/correctness/noUnusedFunctionParameters: TODO
                  onChange={(evt, checked) => this.onClickCheckBox(field, checked)}
                  color="primary"
                  checked={!field.isHiddenColumn}
                />
              </div>
            </div>
          )}
        </Draggable>
      ))
  }

  render() {
    const { isOpenModal, classes, disableReArrange } = this.props
    return (
      <Modal
        label="Table Settings"
        isShowSaveButton
        isShowBottomBar
        className={classes['modal-component']}
        isOpen={isOpenModal}
        handleModalClose={this.toggleModal}
        handleModalSubmit={this.onSave}
        okText={<Text>Apply</Text>}
        cancelText={<Text>Cancel</Text>}
      >
        <DragDropContext onDragEnd={this.onDragEnd}>
          <Droppable droppableId="droppable">
            {provided => (
              <div className={classes.content} ref={provided.innerRef}>
                <div className={cn(classes.row, classes.headerRow)}>
                  {!disableReArrange && <div className={classes.cell10} />}
                  <div className={classes.cell80}>Column Name</div>
                  <div className={classes.cell10}>Visible</div>
                </div>
                {this.renderRow()}
                {provided.placeholder}
              </div>
            )}
          </Droppable>
        </DragDropContext>
      </Modal>
    )
  }
}

export default withStyles(styles)(TableSettingModal)
